function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12 11.523C9.186 11.52 6.902 9.276 6.9 6.5c.002-2.776 2.286-5.022 5.1-5.023 2.815.001 5.098 2.247 5.1 5.023-.002 2.776-2.285 5.021-5.1 5.023M12 0C5.373 0 0 4.883 0 6.5S5.373 13 12 13s12-4.883 12-6.5S18.627 0 12 0"
}), React.createElement("path", {
  d: "M9.2 6.554A2.734 2.734 0 0 0 11.944 9.3 2.742 2.742 0 0 0 14.7 6.554 2.758 2.758 0 0 0 11.944 3.8 2.75 2.75 0 0 0 9.2 6.554z"
}));

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 13",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.802b757f.svg";
export { ForwardRef as ReactComponent };